module.exports = __webpack_public_path__ + "56b10e9e10396d7d546e457c59dec3ea.jpg";